import { boolean, object, string } from 'yup'

const MarketingPreferencesSchema = object().shape({
  first_name: string()
    .required('First name is required')
    .matches(
      /^[A-Za-z-.,'` ]{1,50}$/,
      'First name can only contain letters and basic punctuation',
    )
    .min(2, 'First name must be at least 2 characters')
    .max(50, 'First name must be at most 50 characters')
    .trim(),
  last_name: string()
    .required('Last name is required')
    .matches(
      /^[A-Za-z-.,'` ]{1,50}$/,
      'Last name can only contain letters and basic punctuation',
    )
    .min(2, 'Last name must be at least 2 characters')
    .max(50, 'Last name must be at most 50 characters')
    .trim(),
  email: string()
    .required('Email is required')
    .matches(
      /^([a-z0-9]+(?:[._-][a-z0-9]+)*)@([a-z0-9]+(?:[.-][a-z0-9]+)*\.[a-z]{2,})$/,
      'Email must be a valid email address',
    )
    .max(255)
    .trim(),
  is_lexus: boolean(),
  response_code: string().uppercase().trim(),
  campaign_response_code: string().uppercase().trim(),
  campaign_code: string().uppercase().trim(),
  communication_relevantoffers: boolean().required(),
  contact_phone: boolean().required(),
  contact_email: boolean().required(),
  contact_sms: boolean().required(),
  contact_post: boolean().required(),
  agreement_or_reg_num: string()
    .required('Agreement / Proposal Number  is required')
    .matches(/^[\w]{1,12}$/, 'Please enter your agreement / proposal number'),
})

export default MarketingPreferencesSchema
